import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { KeyRoundIcon, RefreshCwIcon, UsersIcon } from 'lucide-react';
const INSIGHTS = [{
  icon: KeyRoundIcon,
  text: "Your passwords are reused across accounts. We'll walk you through fixing that first."
}, {
  icon: RefreshCwIcon,
  text: "Your devices need a software update. We'll guide you through it in 2 minutes."
}, {
  icon: UsersIcon,
  text: "Three people in your household need their own setup. We'll help you coordinate."
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function FirstLookResultsPage() {
  return <div className="min-h-screen bg-[#1a0647] flex flex-col items-center justify-center px-5 py-10 md:py-16" data-id="element-1463">
      <motion.div className="w-full max-w-md mx-auto flex flex-col items-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-1464">
        {/* Logo */}
        <motion.div variants={itemVariants} className="mb-10" data-id="element-1465">
          <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-6 object-contain opacity-80" data-id="element-1466" />
        </motion.div>

        {/* Headline */}
        <motion.h1 variants={itemVariants} className="text-3xl md:text-4xl font-bold text-white text-center mb-3 leading-tight" data-id="element-1467">
          Here's what needs to happen.
        </motion.h1>

        <motion.p variants={itemVariants} className="text-gray-400 text-center text-base mb-10 max-w-sm" data-id="element-1468">
          Based on your answers, these are the actions that will make the
          biggest difference.
        </motion.p>

        {/* Insight Rows */}
        <div className="w-full space-y-4 mb-10" data-id="element-1469">
          {INSIGHTS.map((insight, idx) => {
          const Icon = insight.icon;
          return <motion.div key={idx} variants={itemVariants} className="flex items-start gap-4 bg-white/[0.06] border border-white/[0.1] rounded-2xl p-5" data-id="element-1470">
                <div className="mt-0.5 shrink-0" data-id="element-1471">
                  <Icon size={22} className="text-[#0EB4CC]" data-id="element-1472" />
                </div>
                <p className="text-white/90 text-base leading-relaxed font-sans" data-id="element-1473">
                  {insight.text}
                </p>
              </motion.div>;
        })}
        </div>

        {/* CTA Button */}
        <motion.div variants={itemVariants} className="w-full" data-id="element-1474">
          <Link to="/signup" className="block w-full text-center py-4 rounded-full font-bold text-lg bg-[#8528e2] text-white hover:bg-[#7322c4] transition-colors shadow-lg no-underline" data-id="element-1475">
            Create Your Free Account to Get Your Action Plan
          </Link>
        </motion.div>

        {/* Secondary Link */}
        <motion.div variants={itemVariants} className="mt-5" data-id="element-1476">
          <button className="text-gray-400 hover:text-white text-sm font-medium transition-colors bg-transparent border-0 cursor-pointer underline underline-offset-2" data-id="element-1477">
            Not now — save my results via email
          </button>
        </motion.div>
      </motion.div>
    </div>;
}